/* eslint-disable complexity */
import moment from "moment"
import { Routers } from "../../../../../../../../constant/Routers"
import { formatDateSaveDB } from "../../../../../../../../utils/getDate"
import { getValueOrUndefined } from "../../../../../../../../utils/getValueOrUndefined"
import {
  ConvertSearchDataSubmitType,
  SchedulesListPostType,
} from "../../../../../models/list"
import { flattenValues } from "../../../../../../../../utils/flattenValues"

const { SCR210_TRAVELERS } = Routers

export const convertSearchDataSubmit = ({
  isPathnameAttentionsOrSafeties,
  isPathnameSchedules,
  pathname,
  searchCondition,
  values,
  userInformation,
}: ConvertSearchDataSubmitType) => {
  const travelerId = pathname === SCR210_TRAVELERS ? "" : values.travelerId
  const { countryToTravel, fullName, projectName } = values
  const _fullName =
    getValueOrUndefined(!isPathnameSchedules, fullName)?.toString() || ""

  const dispatchType = isPathnameSchedules ? "" : searchCondition.dispatchType
  const dispatchTypeDetail = isPathnameSchedules
    ? ""
    : searchCondition.dispatchTypeDetail

  const data: SchedulesListPostType = {
    accommodation: {
      lodgingName: searchCondition.lodgingName,
    },
    assignment: {
      procurementControlNumber: "",
      projectName: projectName,
      projectNameEn: "",
      projectNameJp: "",
      travelPurposeId: searchCondition.travelPurposeId,
    },
    basic: {
      bumonCd: searchCondition.bumonCd,
      dispatchType: dispatchType,
      dispatchTypeDetail: flattenValues(dispatchTypeDetail as string[][]),
      fullName: _fullName,
      kanjiName: "",
      kanjiPassportName: "",
      kanjiPassportSurname: "",
      kanjiSurname: "",
      romajiName: "",
      romajiPassportName: "",
      romajiPassportSurname: "",
      romajiSurname: "",
    },
    contractPersonJp: {
      personCompanyPosition: "",
      personDispatcherName: "",
      personPrefectureResidence: "",
    },
    other: {
      othersDispatchNumber: "",
      othersMemberNumber: "",
      othersStaffNumber: "",
    },
    posting: {
      workPlace: "",
      workPlaceCity: "",
      workPlaceCountry: "",
      workPlaceLocation: "",
    },
    travelerId: isPathnameSchedules ? userInformation?.travelerId : travelerId,
    trip: {
      arrivalCity: values.arrivalCity || searchCondition.arrivalCity,
      arrivalCityCode: searchCondition.arrivalCityCode,
      arrivalCountryCode: "",
      arrivalDateTime: values.arrivalDateTimeDate
        ? formatDateSaveDB(values.arrivalDateTimeDate.toString(), true)
        : "",
      countryToTravel: flattenValues(countryToTravel),
      departureCity: "",
      departureCityCode: "",
      departureCountryCode: "",
      departureDateTime: values.departureDateTimeDate
        ? formatDateSaveDB(values.departureDateTimeDate.toString())
        : isPathnameAttentionsOrSafeties
        ? formatDateSaveDB(moment().toString())
        : "",

      departureFlightNumber: searchCondition.departureFlightNumber,
      transitSearchType: searchCondition.transitSearchType,
      transportation: "",
    },
  }

  return data
}
